import './style.scss';
import Images from 'assets/Images';

export default function HelpIcon(props) {
    const { infoContent } = props;
    return <div className='help-icon__helpContainer'>
        <div className='help-icon__help'>
            <img src={Images.help} />
        </div>
        <div className='help-icon__helpContent'>{infoContent}</div>
    </div>
}